import { BaseApi } from '@/main/baseApi';
import { checkError } from '@/main/services/httpRequest';

import { DMS_MODULE, NAME, API_ND_AREA, NdSklad, ZakazkaNd, Ozakazka, SERVICE_JOB_SPLIT_BILLING } from './constants';

class RezervaceNdProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	async defaultJfnd(filter: {}) {
		return this.post(`/${DMS_MODULE}/${NAME}/defaultForJfnd`, filter);
	}

	async isStockAvailable(VyrobekndOzn: string, NdNr: string, SkladOzn: number) {
		return this.fetch(`/${API_ND_AREA}/${NdSklad}/IsStockAvailable`, { VyrobekndOzn, NdNr, SkladOzn });
	}

	createSRForm(ndData: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/CreateRequisitionForm`, ndData);
	}

	async setAdditionalStatusForZakazkaNdrez(ZakazkaNdrez: number | null, StatusCode: number | null) {
		return this.post(`/${DMS_MODULE}/${NAME}/SetAdditionalStatusForZakazkaNdrez?ZakazkaNdrez=${ZakazkaNdrez}&StatusCode=${StatusCode}`);
	}

	deleteEntitys(data: { zakazkaId: number, zaznamRwids: number[] }) {
		return checkError(this.axiosInstance.delete(`${this.apiPath}Delete`, { data }), true);
	}

	uploadParts(fileList: any, ZakazkaId: null | number, ZakazkaNr: null | number, ZakaznikId: null | number, ZakazkaDruh: null | string, warehouseId: null | number) {
		const file = new FormData();
		file.append('file', fileList.raw, fileList.name);
		return this.uploadMultipart(
			`/${DMS_MODULE}/${NAME}/UploadParts?ZakazkaId=${ZakazkaId}&ZakazkaNr=${ZakazkaNr}&ZakaznikId=${ZakaznikId}&ZakazkaDruh=${ZakazkaDruh}&warehouseId=${warehouseId}`, file);
	}

	getUnitMRPPrice(partNo: string, brand:string, warehouseId: number) {		
		return this.fetch(`/${DMS_MODULE}/${Ozakazka}/GetRrpUnitPrice/`,{ partNo, brand, warehouseId });		
	}

	getPricingDate(partNo: string, brand:string, orderId: number, warehouseId: number) {
		return this.fetch(`/${DMS_MODULE}/${ZakazkaNd}/GetMrp`, { partNo, brand, orderId, warehouseId });
	}

	async getNdpDate(pricingId: number, orderId: number) {
		return this.fetch(`/${DMS_MODULE}/${ZakazkaNd}/GetNdp`, { pricingId, orderId });
	}
	
	async isDNPVisible(orderNo: number) {
		return this.fetch(`/${DMS_MODULE}/${ZakazkaNd}/IsDNPVisible`, { orderNo });
	}

	async getPriceForReserveParts(orderId: number) {
		return this.fetch(`/${DMS_MODULE}/${ZakazkaNd}/GetPriceForReserveParts`, { orderId });
	}

	async getPartsList(brand: string, wearHouse: string) {
		return this.fetch(`/${DMS_MODULE}/${Ozakazka}/GetPartsList?SkladOzn=${wearHouse}&HledejPodretezecNdNr=true&VyrobekndOzn=${brand}`);
	}

	async partReservation(orderReserveDto: any,isFromReservation: boolean, filter: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/PartReservation${(isFromReservation?'?ZakazkaId='+filter.ZakazkaId+'':'')}`, orderReserveDto, filter);
	}

	async getConversionUnits(ndnr: string, skladOzn: number, VyrobekndOzn: string) {
		return this.fetch(`/${API_ND_AREA}/${NdSklad}/GetConversionUnitsForPart`, { ndnr, skladOzn, VyrobekndOzn });
	}

	async checkIfExpiryAvailable(ndNr: string, skladOzn: number) {
		return this.fetch(`/${API_ND_AREA}/${NdSklad}/CheckIfExpiryAvailable/?NdNr=${ndNr}&skladOzn=${skladOzn}`);
	}

	async getPartsPrice(partNumber: string, orderId: number, warehouseId: number | null) {
		return this.fetch(`/${API_ND_AREA}/${NdSklad}/NdSkladByPartNumber?partNumber=${partNumber}&isPlannedOrder=false&orderId=${orderId}&warehouseId=${warehouseId}`);
	}

	getSplitDetails(itemId: number | null, orderId: number | null) {
		return this.fetch(`/${DMS_MODULE}/SplitBilling/GetSplitTooltip`, { itemId, orderId });
	}

	getSectionPartDiscount(orderId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/getSectionPartDiscount?orderId=${orderId}`);
	}

	isWarrantyExistInSplit(itemId: number, orderId:number | null, itemType:string) {
		return this.fetch(`/${DMS_MODULE}/SplitBilling/IsWarrantyOrGoodWillSplitExist`, { itemId, orderId, itemType });
	}
	async CheckDnpValue(OrderId: number) {
		return this.fetch(`/${DMS_MODULE}/${ZakazkaNd}/CheckDnpValue`, { OrderId });
	}
	async getisObsoletePartStock(partNumber: string, warehouseId: number, brand: string, quantity: number) {
		return this.fetch(`/${API_ND_AREA}/${NdSklad}/GetIsObsoletePartStock?partNumber=${partNumber}&quantity=${quantity}&brand=${brand}&warehouseId=${warehouseId}&IsProrder=false`);
	}

	async deleteReservePartFromSplitbilling(orderId: number | null , itemId: number ) {
		return this.delete(`/${DMS_MODULE}/${NAME}/DeleteReservePartFromSplitbillingTable?zakazkaId=${orderId}&itemId=${itemId}`);
	}
	GetTechnicianListByWorkshopId(workshopId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetTechnicianListByWorkshopId?workshopId=${workshopId}`);
	}
   GetServiceJobByZakazkaId(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetServiceJobByZakazkaId?zakazkaId=${zakazkaId}`);
	}
	async GetWarehouse(Ids: any) {
		return this.fetch('/DropdownList/GetWarehouse/', { workshopId: Ids });
	}
	IsServiceJobSplit(serviceOrderId:number, serviceJobId: number){
		return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/IsServiceJobSplit`,{serviceOrderId, serviceJobId});
	}
	async GetCombinedMrpDnp()
	{
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetCombinedMrpDnp`);
	}

	fetchInvoiceStatusOfServiceJobParty(serviceOrderId: number, serviceJobId: number, itemId: number, itemType: string, discountLimitPercent: number) {
		return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/FetchInvoiceStatusOfServiceJobParty`, { serviceOrderId, serviceJobId, itemId, itemType, discountLimitPercent });
	}
}

export const apiProvider = new RezervaceNdProvider();
